import React from 'react';
import { List, Tag, Typography } from 'antd';
import styles from './SearchResultItem.module.scss';

const { Text } = Typography;

interface SearchResultItemProps {
  item: {
    id: number;
    name: string;
    type: string;
    path: string;
    status: string;
    createdAt: string;
    projectName: string;
    fileName: string;
  };
  onItemClick: (item: any) => void;
}

const SearchResultItem: React.FC<SearchResultItemProps> = ({ item, onItemClick }) => {
  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));
    
    if (diffInMinutes < 60) {
      return `${diffInMinutes} dk. önce`;
    } else if (diffInMinutes < 1440) {
      const hours = Math.floor(diffInMinutes / 60);
      return `${hours} sa. önce`;
    } else {
      return date.toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Approved': return 'var(--app-accent-color)';
      case 'NeedsReview': return '#FFC108';
      case 'Updated': return '#E91E63';
      default: return '#666';
    }
  };

  return (
    <List.Item 
      className={styles.resultItem}
      onClick={() => onItemClick(item)}
    >
      <div className={styles.itemContent}>
        <div className={styles.itemInfo}>
          <div className={styles.itemTitle}>
            {item.projectName} - {item.fileName} - {item.name}
          </div>
          <div className={styles.itemPath}>
            {item.path}
          </div>
          <div className={styles.itemMeta}>
            <Tag color={getStatusColor(item.status)}>
              {item.status}
            </Tag>
            <Text type="secondary">
              {formatTime(item.createdAt)}
            </Text>
          </div>
        </div>
      </div>
    </List.Item>
  );
};

export default SearchResultItem; 